import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Nvabar } from './layout/nvabar/nvabar';
import { filter } from 'rxjs';
import { DataService } from './services/data';
import { StorageService } from './services/storage-service';
import { HttpClient } from '@angular/common/http';
import { LoadingService } from './services/loading.service';
import { CommonModule } from '@angular/common';
import { TranslateService } from './shareds/translate/translate.service';
import { TranslateModule } from './shareds/translate/translate.module';
import { ThemeService } from './services/theme.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Nvabar, CommonModule, TranslateModule],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('app-hotel');
  loading = inject(LoadingService);
  private translate = inject(TranslateService);
  private theme = inject(ThemeService);

  constructor(private route: ActivatedRoute, private router: Router,
    private data: DataService,
    private st: StorageService,
    private http: HttpClient
  ) {
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(() => {
        const r = this.getDeepestRoute(this.route);
        r.params.subscribe(p => {
          st.setSession('appId', p['app-id'])
          this.translate.loadLanguageItems(p['app-id']);
          this.theme.loadTheme(p['app-id']);
        });
      });
  }

  private getDeepestRoute(ar: ActivatedRoute): ActivatedRoute {
    let cur = ar;
    while (cur.firstChild) cur = cur.firstChild;
    return cur;
  }
}
